module.exports = __webpack_public_path__ + "static/media/bg-background-mis-unidades.f3f22667.jpg";